import { formatData } from "@shared/lib/utils/formatData";
import { ReportMedia } from "@shared/lib/types/reports";
import { ExternalLink } from "lucide-react";
import styles from "./BasicInsights.module.scss";

interface BasicInsightsProps {
  reportMedia: ReportMedia;
}

type Sentiment = "Positive" | "Negative" | "Neutral";

export function BasicInsights({ reportMedia }: BasicInsightsProps) {
  const getSentiment = (): Sentiment | null => {
    if (!reportMedia.commentData) {
      return null;
    }

    const {
      noOfPostiveComment = 0,
      noOfNegativeComment = 0,
      noOfNeutralComment = 0,
    } = reportMedia.commentData;

    const getMaxSentiment = () => {
      if (
        noOfPostiveComment >= noOfNegativeComment &&
        noOfPostiveComment >= noOfNeutralComment
      ) {
        return "Positive";
      } else if (
        noOfNegativeComment >= noOfPostiveComment &&
        noOfNegativeComment >= noOfNeutralComment
      ) {
        return "Negative";
      } else {
        return "Neutral";
      }
    };

    return getMaxSentiment();
  };

  const sentiment = getSentiment();

  return (
    <div className={styles.container}>
      <div className={styles.thumbnailWrapper}>
        <img
          src={reportMedia.mediaUrl || ""}
          alt="Media thumbnail"
          className={styles.thumbnail}
        />
        <a
          href={reportMedia.link}
          target="_blank"
          rel="noreferrer"
          className={styles.thumbnailOverlay}
        >
          <ExternalLink size={20} className={styles.externalLinkIcon} />
        </a>
      </div>
      <div className={styles.metricsContainer}>
        <div className={styles.metricsGrid}>
          {reportMedia.cost !== undefined && (
            <div className={styles.metricCard}>
              <div className={styles.metricLabel}>Total Cost</div>
              <div className={styles.metricValue}>
                {reportMedia.cost > 0
                  ? `₹${formatData(reportMedia.cost, "0.00")}`
                  : "-"}
              </div>
            </div>
          )}
          {reportMedia.cost !== undefined && (
            <div className={styles.metricCard}>
              <div className={styles.metricLabel}>Campaign CPV</div>
              <div className={styles.metricValue}>
                {reportMedia.cost / (reportMedia.mediaData?.views || 1) > 0
                  ? `₹${formatData(reportMedia.cost / (reportMedia.mediaData?.views || 1), "0.00")}`
                  : "-"}
              </div>
            </div>
          )}
        </div>
        {/* {sentiment && (
          <div className={styles.sentimentContainer}>
            <span className={styles.sentimentLabel}>Sentiment:</span>
            <span
              className={`${styles.sentimentBadge} ${styles[`sentiment${sentiment}`]}`}
            >
              {sentiment}
            </span>
          </div>
        )} */}
      </div>
    </div>
  );
}
